// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"c0f8d4e7","145":"e0fb04af","265":"a375c3a7","965":"a375c3a7"}[chunkId] + ".chunk.css";
};